<template>
  <CoachShell>

    <div class="bg-gradient-to-r from-purple-300 to-blue-200">
      <div class="w-9/12 m-auto py-16 min-h-screen flex items-center justify-center">
        <div class="bg-white shadow overflow-hidden sm:rounded-lg pb-8">
          <div class="border-t border-gray-200 text-center py-4 px-10">
              <div v-if="mode === 'login'">
                <h1 class="text-7xl font-bold text-purple-400 p-5">
                  Log in
                </h1>
                <p class="mt-2 text-center text-sm text-gray-600">
                  No account yet?
                  {{ ' ' }}
                  <a href="#" @click="switchAuthMode" class="font-medium text-purple-700 hover:text-purple-500">
                    Sign up
                  </a>
                </p>
              </div>
              <div v-else>
                <h1 class="text-7xl font-bold text-purple-400 p-5">
                  Sign up
                </h1>
                <p class="mt-2 text-center text-sm text-gray-600">
                  Have account?
                  {{ ' ' }}
                  <a href="#" @click="switchAuthMode" class="font-medium text-purple-700 hover:text-purple-500">
                    Log in
                  </a>
                </p>
              </div>
              <form class="mt-8 space-y-6" @submit.prevent="submitForm">
                <div v-if="!formIsValid" class="rounded-md bg-red-400 p-1 text-center">Please enter valid email and/or username.</div>
                <div class="rounded-md shadow-sm">
                  <div>
                    <label for="email-address" class="sr-only">Email address</label>
                    <input
                        v-model.trim="email"
                        id="email-address" name="email" type="email" autocomplete="email" required=""
                        class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Email address" />
                  </div>
                  <div>
                    <label for="password" class="sr-only">Password</label>
                    <input
                        v-model.trim="password"
                        id="password" name="password" type="password" autocomplete="current-password" required=""
                        class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Password" />
                  </div>
                </div>
                <div class="flex items-center justify-between">
                  <div class="flex items-center">
                    <!--
                    <input type="hidden" name="remember" value="true" />
                      <input id="remember_me" name="remember_me" type="checkbox" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                        <label for="remember_me" class="ml-2 block text-sm text-gray-900">
                          Remember me
                        </label>-->
                  </div>
                  <div class="text-sm" v-if="mode=== 'login'">
                    <a href="#" onclick="alert('Coming Soon!')" class="font-medium text-purple-700 hover:text-purple-500">
                      Forgot your password?
                    </a>
                  </div>
                </div>
                <div>

                  <div v-if="error" class="bg-red-400 rounded-md p-2 mt-5 mb-5 text-white">
                    {{ error }}
                  </div>

                  <base-spinner
                      v-if="isLoading"
                      :label="'Please wait...'"
                      :disabledAttr="'disabled'"
                      class="w-full"
                  ></base-spinner>

                  <base-button
                      v-else
                      :type="'submit'"
                      :mode="'group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-purple-500 hover:bg-purple-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'"
                  >
            <span v-if="mode=== 'login'" class="absolute left-0 inset-y-0 flex items-center pl-3">
              <LockClosedIcon class="h-5 w-5 text-purple-300 group-hover:text-purple-400" aria-hidden="true" />
            </span>
                    <span class="uppercase font-bold tracking-wider">{{ submitButtonCaption }}</span>
                  </base-button>
                </div>
              </form>
          </div>
        </div>
      </div>
    </div>

  </CoachShell>
</template>

<script>
import { LockClosedIcon } from '@heroicons/vue/solid'
import CoachShell from "../pages/find-coach-app/coaches/CoachShell";

export default {
  components: {
    LockClosedIcon,
    CoachShell
  },
  data(){
    return{
      email: '',
      password: '',
      formIsValid: true,
      mode: 'login',
      isLoading: false,
      error: null,
    }
  },
  computed: {
    submitButtonCaption(){
      if( this.mode === 'login')
      {
        return 'Login';

      }else{
        return 'Sign Up';
      }
    }
  },
  methods: {
    async submitForm(){
      //console.log('submit login/reg from form');
      this.formIsValid = true;
      this.isLoading   = true;
      this.error       = '';

      //todo basic validation
      if(
          this.email === '' ||
          !this.email.includes('@') ||
          this.password.length < 6 //todo 6 is required by firebase
      ){
        this.formIsValid = false;
        this.isLoading = false;

        //console.log('form invalid');
        this.error = 'Please fill out all the fields';
        return;
      }

      const actionPayload = {
        email: this.email,
        password: this.password,
      }

      try {
        if (this.mode === 'login') {
          await this.$store.dispatch('login', actionPayload);
        }
        else{
          await this.$store.dispatch('signup', actionPayload);
        }

        this.error       = '';
        await this.$router.replace('/coaches');

      }
      catch(error){
        this.error = error.message || 'There\'s been an error. Please try again. ';
        this.isLoading   = false;
        //console.log(this.error);
      }

      this.isLoading   = false;
    },
    switchAuthMode(){
      //console.log('switchAuthMode');
      if( this.mode === 'login')
      {
        this.error = null;
        this.loading = false;
        this.mode = 'signup';
      }else{
        this.error = null;
        this.loading = false;
        this.mode = 'login';
      }
    }
  },
  mounted() {
   // console.log('store from mounted()', this.$store);
  },
  created() {
   // console.log('store from created()', this.$store);
  },
  updated() {
    //console.log('store from updated()', this.$store);
  }
}
</script>